import { headerStyles as styles } from "@insite/content-library/Widgets/VmiBins/VmiBinsHeader";
import { css } from "styled-components";

styles.titleText = {
    css: css`
        display: none;
    `,
};
